import posthog from 'posthog-js'

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN!, {
  api_host: '/ingest',
  ui_host: 'https://eu.posthog.com',
  defaults: '2026-01-30',
  capture_exceptions: true,
  // Performance monitoring. `web_vitals` sends a standalone `$web_vitals`
  // event per page (LCP, CLS, FCP, INP) — see Web Analytics → Web vitals.
  // `network_timing` only lives inside session replay: it attaches
  // request/response timings to each recording's Network tab, so a slow
  // session can be replayed with the waterfall alongside it. Neither
  // captures request or response bodies (recordBody stays off).
  capture_performance: {
    web_vitals: true,
    network_timing: true,
  },
  // Adds X-POSTHOG-SESSION-ID / X-POSTHOG-DISTINCT-ID to same-origin fetches
  // (API calls and Next's own navigations), which proxy.ts copies onto the
  // server trace — so a slow request in PostHog Traces links back to the
  // person and the session replay it came from. Same-origin only: nothing
  // is added to requests leaving this host.
  tracing_headers: [window.location.hostname],
  debug: process.env.NODE_ENV === 'development',
  // Clinical app: client/patient PII and note text must never reach PostHog.
  // Autocapture events keep the click but drop element text; replays mask
  // every input. Rendered PII/free text is blocked element-by-element with
  // <Redacted> (ph-no-capture) — see components/redacted.tsx.
  mask_all_text: true,
  session_recording: {
    maskAllInputs: true,
  },
})
